import Markdown from "markdown-to-jsx";
import { FaFacebook, FaLinkedin, FaSquareInstagram } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { Design } from "../assets";
import SidePanel from "../pages/side/SidePanel";

const Banner = ({ post }) => {
  return (
    <div className="w-full mb-10 min-h-screen">
      <div className="md:relative w-full md:h-[500px] 2xl:h-[600px] flex flex-col md:flex-row px-0 lg:px-20">
        <div className="md:max-w-[1480px] m-auto grid md:grid-cols-2 max-w-[600px]  px-4 md:px-0">
          <div className="flex flex-col justify-start gap-4">
            <p className="md:py-2 text-xl md:text-2xl text-dr_gray font-medium">
              START TO SUCCESS
            </p>
            <h1 className="md:leading-[65px] md:py-2 md:text-5xl text-2xl font-semibold text-black dark:text-white">
              <span className="md:py-2 text-base md:text-lg text-hl">
                Let’s make your brand shine in the world.
              </span>
              <br />
              <span className="text-hl">Brand Identity, </span>
              <span className="text-hl">User experience</span>,{' '}
              <span className="border-b-5 underline decoration-h5 decoration-2">
                and Online success
              </span>
            </h1>
            <p className="md:py-2 text-base md:text-lg text-dr_gray">
              Establish your personal brand online and make your online presence
              stand out with style and professionalism.
            </p>
            <div className="hidden md:flex gap-4">
              <a
                href="/contact"
                className="btn btn-primary has-before has-after rounded-md text-white"
              >
                Let’s Talk
              </a>
              <a
                href="#"
                className="btn has-before has-after rounded-md text-black underline dark:text-white decoration-h5 decoration-2"
              >
                Call us
              </a>
            </div>
            <div className="md:hidden">
              <a
                href="#"
                className="py-4 border border-dr_gray has-before has-after rounded-md text-black underline dark:text-white decoration-h5 decoration-2"
              >
                Call us
              </a>
            </div>
            <div className="flex gap-2 items-center justify-center  text-[20px] mt-4 lg:flex md:mt-10">
              <Link to="/" className="text-[#0077B5] flex gap-2 items-center">
                <FaLinkedin size={20} />
                <p className="text-dr_gray text-[14px] hidden md:block font-semibold uppercase">
                  Instagram
                </p>
              </Link>
              <Link to="/" className="text-blue-600 flex gap-2 items-center">
                <FaFacebook size={20} />
                <p className="text-dr_gray text-[14px] hidden md:block font-semibold uppercase">
                  Facebook
                </p>
              </Link>
              <Link to="/" className="text-rose-600 flex gap-2 items-center">
                <FaSquareInstagram size={20} />
                <p className="text-dr_gray text-[14px] hidden md:block font-semibold uppercase">
                  Instagram
                </p>
              </Link>
            </div>
          </div>
        </div>
        <div className="md:absolute md:right-10 h-full">
          <figure className="">
            <img
              src={Design}
              alt="design"
              className="max-w-[320px] object-contain"
            />
          </figure>
          <div className="flex flex-col md:right-10 bottom-10 md:bottom-2 w-full md:w-2/4 lg:w-1/3 2xl:w-[480px] bg-white dark:bg-[#05132b] shadow-2xl p-5 rounded-lg gap-3">
            <Link to={`/${post?.slug}/${post?._id}`}>
              <h1 className="font-semibold text-2xl text-black dark:text-white">
                {post?.title.slice(0, 60) + "..."}
              </h1>
            </Link>

            <div className="flex-1 overflow-hidden text-gray-dr_gray text-base text-justify">
              <Markdown options={{ wrapper: "article" }}>
                {post?.desc?.slice(0, 160) + "..."}
              </Markdown>
            </div>
            <SidePanel />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
